import React, { useEffect, useState } from "react";
import api from "../api/axios";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import DocumentViewer from "../components/modal/DocumentViewer";

function OnboardProcess() {
  const [onboards, setOnboards] = useState([]);
  const [loading, setLoading] = useState(true);

  // Document Viewer
  const [showDocs, setShowDocs] = useState(false);
  const [docClientId, setDocClientId] = useState(null);
  const [docClientName, setDocClientName] = useState("");

  // NEW: Status Modal
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [status, setStatus] = useState("");
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Success Modal
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  // Fetch list
  const fetchOnboards = async () => {
    setLoading(true);
    try {
      const res = await api.get("/onboard-verification-list/" + branch_id, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOnboards(res.data.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOnboards();
  }, []);

  // View Docs
  const handleViewDocuments = (clientId, clientName) => {
    setDocClientId(clientId);
    setDocClientName(clientName);
    setShowDocs(true);
  };

  // Open Status Modal
  const openStatusModal = (clientId) => {
    setSelectedClientId(clientId);
    setStatus("");
    setComment("");
    setShowStatusModal(true);
  };

  const closeStatusModal = () => {
    setShowStatusModal(false);
    setSelectedClientId(null);
  };

  // Submit Status
  const submitStatus = async () => {
    if (!selectedClientId || !status) return;

    setSubmitting(true);
    try {
      await api.post(
        "/accounts-verification",
        {
          id: selectedClientId,
          status: status,
          comment: comment,
          title: "Onboarding Status Updated",
          message: "Onboarding status updated by account team",
          link: "ceo-dashboard-on-board-sign",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSuccessMessage("✅ Status updated successfully!");
      setShowSuccessModal(true);
      setShowStatusModal(false);
      fetchOnboards();
    } catch (err) {
      console.error("Submit failed:", err);
      setSuccessMessage("❌ Failed to update status.");
      setShowSuccessModal(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* Title */}
      <div className="row">
        <div className="col-12">
          <h4>Client Onboard Verification</h4>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th>Client Name</th>
                        <th>Contact</th>
                        <th>Office</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {onboards.length > 0 ? (
                        onboards.map((item) => (
                          <tr key={item.id}>
                            <td>{item.company_name || "-"}</td>
                            <td>{item.contact_number || "-"}</td>
                            <td>{item.office?.office_no || "-"}</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm me-2"
                                onClick={() =>
                                  handleViewDocuments(item.id, item.company_name)
                                }
                              >
                                Documents
                              </button>

                              <button
                                className="btn btn-warning btn-sm"
                                onClick={() => openStatusModal(item.id)}
                              >
                                Update Status
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Document Viewer */}
      <DocumentViewer
        clientId={docClientId}
        clientName={docClientName}
        show={showDocs}
        onClose={() => setShowDocs(false)}
      />

      {/* NEW STATUS MODAL */}
      <Modal show={showStatusModal} className="modal-lg" onHide={closeStatusModal} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Update Status</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="holding">Holding</option>
                <option value="verified">Verified</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Comment / Feedback</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter feedback..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeStatusModal}>
            Cancel
          </Button>

          <Button variant="success" onClick={submitStatus} disabled={submitting}>
            {submitting ? (
              <>
                <Spinner size="sm" className="me-2" />
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>{successMessage}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowSuccessModal(false)}>OK</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OnboardProcess;